import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, FileText, ShoppingCart, BarChart3, MapPin, Calculator, Eye, MessageCircle } from 'lucide-react';
import { cn } from '../../lib/utils';
import weavrLogo from '../../images/weavr.png';

const Sidebar = () => {
  const navigation = [
    {
      name: 'Homepage',
      href: '/',
      icon: Home,
      description: 'Media Mix Modelling Overview'
    },
    {
      name: 'PO Reconciliation',
      href: '/po-reconciliation',
      icon: FileText,
      description: 'Purchase Order Matching & Verification'
    },
    {
      name: 'Buying Repository',
      href: '/buying-repository',
      icon: ShoppingCart,
      description: 'Media Rates & Price Benchmarking'
    },
    {
      name: 'Integrations',
      href: '/integrations',
      icon: BarChart3,
      description: 'System Integrations & Data Connectors'
    },
    {
      name: 'UAE Outdoor',
      href: '/uae-outdoor',
      icon: MapPin,
      description: 'UAE Outdoor Advertising Analytics'
    },
    {
      name: 'Budget Simulator',
      href: '/budget-simulator',
      icon: Calculator,
      description: 'Budget Planning & Event Forecasting'
    },
    {
      name: 'Creative Audit',
      href: '/creative-audit',
      icon: Eye,
      description: 'Creative Performance & Optimization'
    }
    ,
    {
      name: 'Chatbot',
      href: '/chatbot',
      icon: MessageCircle,
      description: 'AI Media Insights Chatbot'
    }
  ];

  return (
    <div className="w-64 bg-white border-r border-gray-200 shadow-sm h-screen flex flex-col">
      {/* Header */}
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center space-x-3">
          <div className="h-12 w-12 rounded-lg flex items-center justify-center">
            <img src={weavrLogo} alt="Weavr" className="h-8 w-8 object-contain" />
          </div>
          <div>
            <h1 className="text-lg font-bold bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
              Weavr
            </h1>
            <p className="text-xs text-gray-500">Media Analytics Platform</p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2">
        {navigation.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={({ isActive }) =>
                cn(
                  'group flex flex-col p-3 rounded-lg text-sm font-medium transition-all duration-200',
                  isActive
                    ? 'bg-gradient-to-r from-blue-50 to-purple-50 text-blue-700 border border-blue-200'
                    : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                )
              }
            >
              {({ isActive }) => (
                <>
                  <div className="flex items-center space-x-3">
                    <Icon className={cn(
                      'h-5 w-5 flex-shrink-0',
                      isActive ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-600'
                    )} />
                    <span className="font-semibold">{item.name}</span>
                  </div>
                  <p className={cn(
                    'text-xs mt-1 ml-8',
                    isActive ? 'text-blue-600' : 'text-gray-500'
                  )}>
                    {item.description}
                  </p>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-200">
        <div className="text-xs text-gray-500 text-center">
          <p>Weavr Analytics Platform</p>
          <p className="mt-1">v2.0 • {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;